import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import { FaTasks } from "react-icons/fa";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { updateSeenNotification } from "../../pages/Services/NotificationService";
import { withSnackbar } from "../../utils/SnackbarHOC";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  timeTypography: {
    fontSize: "0.6875rem"
  },
}));

function TaskNotification({ notif, snackbarShowMessage, onUpdate }) {
  const classes = useStyles();

  const updateNotification = async () => {
    if (notif.seen) return;
    try {
      await updateSeenNotification(notif.uuid);
      onUpdate({ ...notif, seen: true });
    } catch (error) {
      snackbarShowMessage(
        "Erreur lors de la mise à jour de la notification",
        "error",
        2000
      );
    }
  };

  const getTimeAgo = (dateString) => {
    moment.locale("fr");
    const date = moment(dateString, "DD-MM-YYYY HH:mm:ss");
    return moment(date).fromNow();
  };

  return (
    <ListItem
      button
      component={Link}
      to={{ pathname: `/candidats/${notif.candidat}/view` }}
      key={notif.uuid}
      dense
      selected={!notif.seen}
      divider
      onClick={updateNotification}
    >
      <ListItemAvatar>
        <Avatar>
          <FaTasks />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={`Nouvelle tâche assignée pour le candidat : ${notif.candidatName}`}
      />
      <ListItemText classes={{ primary: classes.timeTypography }} primary={getTimeAgo(notif.createdAt)} />
    </ListItem>
  );
}

TaskNotification.propTypes = {
  notif: PropTypes.shape({
    candidat: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired,
    seen: PropTypes.bool.isRequired,
    candidatName: PropTypes.string.isRequired,
  }).isRequired,
};

export default withSnackbar(TaskNotification);
